export default function({slug}){
  return `
<div class="page">
  <notation-view slug="${slug}" show="controls,title,options"></notation-view>
</div>
  `
}
